export default "/_next/static/images/service-boarding-desktop-3x-23d46424f85fda61847ddde2045957ba.jpg";